// Homepage defaults (EN + FR): today's homepage content, used for any field the
// admin leaves empty and to seed the admin draft (scripts/seed-site-pages.js home).
// One file per homepage section; the keys match backend/homeSpec/*.
import seo from "./seo";
import hero from "./hero";
import about from "./about";
import team from "./team";
import logos from "./logos";
import tiers from "./tiers";
import testimonial from "./testimonial";
import faq from "./faq";
import cases from "./cases";
import seoText from "./seoText";
import cta from "./cta";
import layout from "./layout";

const SECTIONS = { seo, hero, about, team, logos, tiers, testimonial, faq, cases, seoText, cta, layout };

const pick = (lang) => Object.fromEntries(Object.entries(SECTIONS).map(([k, v]) => [k, v[lang] || {}]));

const HOME_DEFAULTS = { en: pick("en"), fr: pick("fr") };

export default HOME_DEFAULTS;
